import { createApp } from 'vue'

export type VueComponent = new (...args: unknown[]) => { ['$props']: Record<string, unknown> }

export type VueComponentProps<C extends VueComponent> = InstanceType<C>['$props']

export function vueCreateApp<C extends VueComponent, P extends VueComponentProps<C>>(component: C, props: P) {
  return createApp(component, props)
}

interface CurrentRoute {
  params: Record<string, string>
  query: Record<string, string>
}

export function vueRoute<C extends VueComponent, P extends VueComponentProps<C>>(opts: {
  path: string
  name?: string
  component: C
  props: P | ((route: CurrentRoute) => P)
  meta?: Record<string, unknown>
}) {
  return opts
}
